import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonNav, IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { MasterHomePageRoutingModule } from './master-home-routing.module';

import { MasterHomePage } from './master-home.page';
import { MobipaidPageModule } from '../payment-gateway/non-recurring/mobipaid/mobipaid.module';
import { ContactFormPageModule } from '../contact-form/contact-form.module';
import { AccountDetailsPageModule } from '../account-details/account-details.module';
import { PaymentOptionPageModule } from '../payment-plan/payment-option/payment-option.module';
import { PaymentFrequencyPageModule } from '../payment-plan/payment-frequency/payment-frequency.module';
import { PaymentDatePageModule } from '../payment-plan/payment-date/payment-date.module';
import { PaymentMethodPageModule } from '../payment-plan/payment-method/payment-method.module';
import { USAEPAYCardPageModule } from '../payment-gateway/recurring/usaepay/usaepay-card/usaepay-card.module';
import { PersonalDetailPageModule } from '../personal-detail/personal-detail.module';
import { USAEPAYAchPageModule } from '../payment-gateway/recurring/usaepay/usaepay-ach/usaepay-ach.module';
import { CaseDetailPageModule } from '../case-detail/case-detail.module';
import { StripepayPageModule } from '../payment-gateway/non-recurring/stripepay/stripepay.module';
import { USAEPaymentMethodPageModule } from '../payment-gateway/non-recurring/usaepay/usaepay-method/usaepay-method.module';
import { USAEPayAchPageModule } from '../payment-gateway/non-recurring/usaepay/usaepay-ach/usaepay-ach.module';
import { USAepayCardPageModule } from '../payment-gateway/non-recurring/usaepay/usaepay-card/usaepay-card.module';
import { PayRocPageModule } from '../payment-gateway/non-recurring/payroc/payroc.module';
import { NmiPageModule } from '../payment-gateway/non-recurring/nmi/nmi.module';
import { TrustPaymentPageModule } from '../payment-gateway/non-recurring/trust-payment/trust-payment.module';
import { TrustPaymentMethodPageModule } from '../payment-gateway/non-recurring/trust-payment/trust-payment-method/trust-payment-method.module';
import { TrustPaymentDigitalWalletPageModule } from '../payment-gateway/non-recurring/trust-payment/trust-payment-digital-wallet/trust-payment-digital-wallet.module';
import { BankPaymentPageModule } from '../payment-plan/bank-payment/bank-payment.module';
import { PaymentGatewaysPageModule } from '../payment-plan/payment-gateways/payment-gateways.module';
import { PaymentPlanRequestPageModule } from '../payment-plan-request/payment-plan-request.module';
import { GoCardlessPageModule } from '../payment-gateway/non-recurring/gocardless/gocardless.module';
import { AcquiredPageModule } from '../payment-gateway/non-recurring/acquired/acquired.module';
import { TrxServicesCardPageModule } from '../payment-gateway/non-recurring/trxservices/trxservices-card/trxservices-card.module';
import { TrxServicesMethodPageModule} from '../payment-gateway/non-recurring/trxservices/trxservices-method/trxservices-method.module';
import { TrxServicesAchPageModule } from '../payment-gateway/non-recurring/trxservices/trxservices-ach/trxservices-ach.module';
import { CustomAmountPageModule } from '../payment-plan/custom-amount/custom-amount.module';
import { CustomPayOptionsPageModule } from '../payment-plan/custom-pay-options/custom-pay-options.module';
import { ViewPaymentPlanPageModule } from '../view-payment-plan/view-payment-plan.module';
import { RepayPageModule } from '../payment-gateway/non-recurring/repay/repay.module';
import { RepayAchPageModule } from '../payment-gateway/non-recurring/repay/repay-ach/repay-ach.module';
import { RepayMethodPageModule } from '../payment-gateway/non-recurring/repay/repay-method/repay-method.module';
import { RepayDigitalWalletPageModule } from '../payment-gateway/non-recurring/repay/repay-digital-wallet/repay-digital-wallet.module';
import { TrxservicesCardPageModule } from '../payment-gateway/recurring/trxservices/trxservices-card/trxservices-card.module';
import { TrxservicesAchPageModule } from '../payment-gateway/recurring/trxservices/trxservices-ach/trxservices-ach.module';
import { TrustPaymentCardPageModule } from '../payment-gateway/recurring/trustpayment/trustpayment-card/trustpayment-card.module';
import { CustomFormPageModule } from '../custom-form/custom-form.module';
import { AmountPaymentPlanPageModule } from '../amount-payment-plan/amount-payment-plan.module';
import { EzidebitMethodPageModule } from '../payment-gateway/non-recurring/ezidebit/ezidebit-method/ezidebit-method.module';
import { EzidebitCardPageModule } from '../payment-gateway/non-recurring/ezidebit/ezidebit-card/ezidebit-card.module';
import { EzidebitRecurringCardPageModule } from '../payment-gateway/recurring/ezidebit/ezidebit-card/ezidebit-card.module';
import { RepayModule } from '../payment-gateway/recurring/repay/repay.module';
import { DdConsentFormPageModule } from '../payment-plan/dd-consent-form/dd-consent-form.module';
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [IonNav],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    MasterHomePageRoutingModule,
    MobipaidPageModule,
    ContactFormPageModule,
    AccountDetailsPageModule,
    PaymentOptionPageModule,
    PaymentFrequencyPageModule,
    PaymentDatePageModule,
    PaymentMethodPageModule,
    USAEPAYCardPageModule,
    PersonalDetailPageModule,
    USAEPAYAchPageModule,
    CaseDetailPageModule,
    StripepayPageModule,
    USAEPaymentMethodPageModule,
    USAEPayAchPageModule,
    USAepayCardPageModule,
    PayRocPageModule,
    NmiPageModule,
    TrustPaymentPageModule,
    TrustPaymentMethodPageModule,
    TrustPaymentDigitalWalletPageModule,
    BankPaymentPageModule,
    PaymentGatewaysPageModule,
    PaymentPlanRequestPageModule,
    GoCardlessPageModule,
    AcquiredPageModule,
    TrxServicesMethodPageModule,
    TrxServicesCardPageModule,
    TrxServicesAchPageModule,
    CustomAmountPageModule,
    CustomPayOptionsPageModule,
    ViewPaymentPlanPageModule,
    RepayPageModule,
    RepayAchPageModule,
    RepayMethodPageModule,
    RepayDigitalWalletPageModule,
    TrxservicesCardPageModule,
    TrxservicesAchPageModule,
    TrustPaymentCardPageModule,
    CustomFormPageModule,
    AmountPaymentPlanPageModule,
    EzidebitMethodPageModule,
    EzidebitCardPageModule,
    EzidebitRecurringCardPageModule,
    RepayModule,
    DdConsentFormPageModule,
  ],
  declarations: [MasterHomePage],
})
export class MasterHomeModule {}
